import PropTypes from "prop-types";
import React, { useState } from "react";
import Slideshow from "components/shared/stays/Slideshow";
import Button from "solar/components/Button";
import SectionRhythm from "components/shared/stays/SectionRhythm";
import GalleryItem from "components/stay/GalleryItem";
import styles from "components/stay/Gallery.module.scss";

function Gallery(props) {
  const { gallery } = props;
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const [activeIndex, setActiveIndex] = useState(1);

  const handleShow = (active) => {
    setShow(true);
    setActiveIndex(active);
  };

  return (
    <>
      <div className={styles.component}>
        <div className={styles.gallery}>
          {gallery?.slice(0, 4).map((item) => (
            <GalleryItem
              key={item.id}
              onClick={() => handleShow(item.position)}
              src={item.file.url}
            />
          ))}
        </div>
        <SectionRhythm>
          <Button onClick={() => handleShow(activeIndex)} ghost responsive>
            {"Show "}
            {gallery?.length}
            {" photos"}
          </Button>
        </SectionRhythm>
      </div>
      <Slideshow
        show={show}
        handleClose={handleClose}
        initialSlide={activeIndex}
        slides={gallery}
      />
    </>
  );
}

Gallery.propTypes = {
  gallery: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      position: PropTypes.number,
      created_at: PropTypes.string,
      file: PropTypes.shape({
        url: PropTypes.string,
        content_type: PropTypes.string,
        byte_size: PropTypes.number,
      }),
    })
  ).isRequired,
};

export default Gallery;
